import React from 'react';

require('css-circle-menu/js/src/circleMenu.js');
require('css-circle-menu/css/circle-menu.css');
import read_along_icon from "../images/intervention_icons/read_along.svg";
import { getMenuInterventions } from "../services/interventionManager";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

export default class Menu extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      menuController: {},
      open: false,
    };
  }

  componentDidMount(){
    let menuElement = '.js-menu';
    this.setState({
      menuController: cssCircleMenu(menuElement),
    });
  }

  closeMenu(){
    this.state.menuController.closeMenu();
    this.props.onClose(true);   //TODO: 'true' here is to tell the enableListen function to start listening when listening is enabled. Think about more elegant ways to do this
    this.setState({
      open: false,
    });
  }

  openMenu(){
    this.state.menuController.openMenu();
    this.props.onOpen();
    this.setState({
      open: true,
    });
  }

  toggleMenu(){
    if(this.state.open){
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  // this intervention is being handled directly by the ReaderManager
  readAloud(){
    this.closeMenu();
    this.props.interventions.readAloud();
  }

  // we handle the interventions that live in the InterventionManager
  handleClick(menuItem){
    if(menuItem && !menuItem.triggerIntervention){//In case there's no Intervention Handler
      console.warn("no trigger for this Intervention: ", menuItem.title);
      return;
    }
    this.closeMenu();
    const word = this.props.interventions.getCurrentWord().toUpperCase();
    menuItem.triggerIntervention(word, this.props.interventions.openWordInterventionModal.bind(this));
  }

  // generate the Menu Items UI with getMenuInterventions() with the exception of readAloud
  getMenuItems(){
    return getMenuInterventions().map(menuItem =>
      <li key={menuItem.title} className="menuItem c-circle-menu__item" {...doNotUseAccessibleStaticElementInteractions({onClick: () => this.handleClick(menuItem)})}>
        <div className="c-circle-menu__link" title={menuItem.title}>
          <img className="menuIcon" src={menuItem.icon} alt=""/>
        </div>
      </li>
    );
  }

  render(){
    // this structure and these class names are dictated by the circle menu plugin
    // TODO: simplify this, or further wrap it, and consider bringing some of the styling up out of the plugin
    return (
      <nav className="menu c-circle-menu js-menu">
        <button className="c-circle-menu__toggle js-menu-toggle" onClick={this.toggleMenu.bind(this)}>
          <span>Toggle</span>
        </button>
        <ul className="c-circle-menu__items">
          <li key="Read Aloud" className="menuItem c-circle-menu__item">
            <div className="c-circle-menu__link" title="Read Aloud" {...doNotUseAccessibleStaticElementInteractions({onClick: this.readAloud.bind(this)})}>
              <img className="menuIcon" src={read_along_icon} alt=""/>
            </div>
          </li>
          {this.getMenuItems()}
        </ul>
        <div className="c-circle-menu__mask js-menu-mask"></div>
      </nav>
    );
  }
}